var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 102 128",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "Page-1",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd"
          }
        },
        [
          _c("g", { attrs: { id: "podlove", fill: "#FFFFFF" } }, [
            _c("path", {
              attrs: {
                id: "Shape",
                d:
                  "M75.096,97.551 L75.096,90.91 C75.096,89.787 74.994,88.691 74.848,87.605 C86.077,79.835 93.456,66.73 93.456,51.87 C93.456,28.012 74.447,8.672 51,8.672 C27.553,8.672 8.544,28.012 8.544,51.87 C8.544,66.441 15.655,79.301 26.516,87.125 C26.324,88.361 26.194,89.619 26.194,90.91 L26.194,97.146 C10.603,88.283 0.053,71.334 0.053,51.87 C0.053,23.241 22.864,0.032 51,0.032 C79.137,0.032 101.946,23.24 101.946,51.87 C101.946,71.631 91.079,88.803 75.096,97.551 Z M17.036,51.87 C17.036,32.785 32.243,17.311 51,17.311 C69.759,17.311 84.964,32.784 84.964,51.87 C84.964,62.885 79.883,72.676 71.991,79.004 C70.581,76.479 68.733,74.236 66.553,72.363 C72.577,67.625 76.473,60.218 76.473,51.87 C76.473,37.556 65.068,25.951 50.999,25.951 C36.931,25.951 25.526,37.556 25.526,51.87 C25.526,60.042 29.251,67.32 35.06,72.072 C32.845,73.906 30.977,76.134 29.522,78.634 C21.904,72.297 17.036,62.664 17.036,51.87 Z M35.263,51.894 C35.263,43.037 42.347,35.856 51.087,35.856 C59.827,35.856 66.912,43.037 66.912,51.894 C66.912,60.753 59.827,67.932 51.087,67.932 C42.347,67.932 35.263,60.752 35.263,51.894 Z M50.642,75.812 C59.576,75.812 66.818,83.054 66.818,91.988 L66.818,111.795 C66.818,120.727 59.576,127.969 50.642,127.969 C41.709,127.969 34.467,120.727 34.467,111.795 L34.467,91.988 C34.467,83.055 41.709,75.812 50.642,75.812 Z"
              }
            })
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }